import { activityFetch as fetch } from '../feedback/requestActivity'
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './style.css';
import document from '../../resource/image/document.jpg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faGear } from "@fortawesome/free-solid-svg-icons";
import ProjectForm from '../../screen/Project/ProjectSubmit';
import { reqPost } from '../../Service';

export default function ProjectCard(props) {
  const [projectDetailVisible, setProjectDetailVisible] = useState(false);
  const {
    onModify,
    proj_id: proj_id,
    file_id: file_id,
    proj_name: projectName,
    proj_intro: projectDescription,
    proj_url: url,
    proj_github: github,
    proj_remote: remote,
    image_url: imageUrl,
    manager: manager,
    host_name: hostName,
    port_number: portNumber,
    file_server: fileServer,
    database_info: database,
    color_value: colorValue,
    sub_color: subColorValue,
    proj_needs: projectNeeds,
    refresh: refresh,
  } = props;


  /**프로젝트 디테일 더보기 토글 */
  const handleButtonClick = () => {
    setProjectDetailVisible(!projectDetailVisible);
  };

  /**프로젝트 삭제 */
  const deleteProject = (file_id) => {
    const projectName = props.projectName || "해당 프로젝트";
    if (!window.confirm(`[${projectName}]를 정말 삭제하시겠습니까?`)) {
      return;
    }
  
    fetch(`/api/projectDelete`, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({file_id})
    })
    .then((res) => {
      if (!res.ok) {
        return res.json().then(json => { throw new Error(json.message || `상태 코드 ${res.status}`); });
      }
      return res.json();
    })
    .then((msg) => {
      console.log('DeleteStdInfo 리턴값:', msg);
      alert(`${projectName}이(가) 성공적으로 삭제되었습니다.`);
      refresh();
    })
    .catch(err => {
      console.error(err);
      alert(`삭제 중 에러 발생: ${err.message}`);
    });
      };
  
  /**최상단으로 이동 */
  const scrollToTop = () => {
    (document.querySelector('.console-content') || window).scrollTo({
      top: 0,
      behavior: 'smooth' 
    });
  };


  /**수정 클릭 시 수정 상태만 props로 전달 */
  const handleModfiyClick = () => {
    onModify(props); 
    scrollToTop();
  };

  return (
    <div className="ProjectCard">
      <div className="projectHead">
        <h2>{props.projectName}</h2>
        <h3>{props.projectDescription}</h3>
        <span className='projectHeaderBtnSet'>
          <button><FontAwesomeIcon icon={faGear} onClick={handleModfiyClick} /></button>
          <button><FontAwesomeIcon icon={faXmark} onClick={() => deleteProject(file_id)} /></button>
        </span>
      </div>
      <div className='projectInfo'>
      <img src={props.imageUrl} style={{ width: '24.5rem',height:'18rem' ,borderRadius:'30px',margin:'0px'}} />
        <ul className='projectUlInfo'>
          <div className="projectBtnSet">
            <a className="urlBtn" href={props.url} target='_blank' rel="noreferrer">URL</a>
            <a className="githubBtn" href={props.github} target='_blank' rel="noreferrer">Github</a>
            <a className="remoteBtn" href={props.remote} target='_blank' rel="noreferrer">Remote</a>
            <br />
          </div>
          <div style={{width:'100%',height:'90%',padding:'10px'}} className="projectInfoDetail">
          <p style={{display:'none'}}>ProjectId : {props.proj_id} </p>
          <p style={{display:'none'}}>FileId : {props.file_id} </p>

            {/* <p>담당자 : {props.manager} </p> */}
            <p>호스트 이름 : {props.hostName} </p>
            <p>포트번호 : {props.portNumber} </p>
            <p>파일서버 주소 : {props.fileServer} </p>
            <p>DataBase : {props.database} </p>
          </div>
        </ul>

      </div>
      <div className='ShowBtn'><button onClick={handleButtonClick} /></div>
      <div className={projectDetailVisible ? 'projectDetail' : 'projectDetail hide'}>
        <hr width='100%' color='lightgray' />
        <div className='projectInfo'>
          <ul className='ulInfo'>
            <span>Key Color : <input id='colorBox' type="color" defaultValue={props.colorValue} /> {props.colorValue} </span>
            <span>Sub Color : <input id='colorBox' type="color" defaultValue={props.subColorValue} />{props.subColorValue}</span>
            <p>디자인 요구사항 : {props.projectNeeds}</p>
          </ul>
        </div>
      </div>
    </div>

  );
}
